var lib_core = require("lib-core");

var SolderPasteData = function (shape, onTopLayer) {
    var self = this;

    this.makeObservableTreeNode();

    this.shape = this.value("shape", true);

    this.onTopLayer = this.value("onTopLayer", true);

    if(shape != undefined) this.shape(shape);
    if(onTopLayer != undefined) this.onTopLayer(onTopLayer);

    var addShapeShadows = function () {
        if(self.shape()) {
            self.geometry = self.shape().geometry;
            self.segmentedGeometry = self.shape().segmentedGeometry;
            self.boundingBox = self.shape().boundingBox;
        }
    };

    if(this.shape()) addShapeShadows();
    this.shape.onChange("shapeChanged", addShapeShadows);
};
lib_core.mixin(SolderPasteData, lib_core.ObservableTreeNode);

lib_core.JsonParser.registerClass(SolderPasteData, "SolderPaste");

module.exports = SolderPasteData;

SolderPasteData.prototype.move = function (vec) {
    return this.shape() && this.shape().move(vec);
};

SolderPasteData.prototype.rotate = function (angle) {
    return this.shape() && this.shape().rotate(angle);
};

SolderPasteData.prototype.flip = function (flipline) {
    return this.shape() && this.shape().flip(flipline);
};

